// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AutoDismissController from "./auto_dismiss_controller"
application.register("auto-dismiss", AutoDismissController)

import AutosaveController from "./autosave_controller"
application.register("autosave", AutosaveController)

import ColumnPreviewController from "./column_preview_controller"
application.register("column-preview", ColumnPreviewController)

import ColumnTemplateController from "./column_template_controller"
application.register("column-template", ColumnTemplateController)

import ConditionalFieldsController from "./conditional_fields_controller"
application.register("conditional-fields", ConditionalFieldsController)

import ConditionalLanesController from "./conditional_lanes_controller"
application.register("conditional-lanes", ConditionalLanesController)

import DateBoundsController from "./date_bounds_controller"
application.register("date-bounds", DateBoundsController)

import DependentSelectController from "./dependent_select_controller"
application.register("dependent-select", DependentSelectController)

import DepositChecklistController from "./deposit_checklist_controller"
application.register("deposit-checklist", DepositChecklistController)

import DisclosureController from "./disclosure_controller"
application.register("disclosure", DisclosureController)

import DynamicModalController from "./dynamic_modal_controller"
application.register("dynamic-modal", DynamicModalController)

import FileInputController from "./file_input_controller"
application.register("file-input", FileInputController)

import FileReplaceController from "./file_replace_controller"
application.register("file-replace", FileReplaceController)

import FilterController from "./filter_controller"
application.register("filter", FilterController)

import MarkdownEditorController from "./markdown_editor_controller"
application.register("markdown-editor", MarkdownEditorController)

import MaskedFieldController from "./masked_field_controller"
application.register("masked-field", MaskedFieldController)

import NestedFormController from "./nested_form_controller"
application.register("nested-form", NestedFormController)

import PollController from "./poll_controller"
application.register("poll", PollController)

import ScoringListController from "./scoring_list_controller"
application.register("scoring-list", ScoringListController)

import SearchFilter__CheckboxesController from "./search_filter/checkboxes_controller"
application.register("search-filter--checkboxes", SearchFilter__CheckboxesController)

import SearchFilter__DateRangeController from "./search_filter/date_range_controller"
application.register("search-filter--date-range", SearchFilter__DateRangeController)

import SearchFormController from "./search_form_controller"
application.register("search-form", SearchFormController)

import SelectDisclosureController from "./select_disclosure_controller"
application.register("select-disclosure", SelectDisclosureController)

import ShowMoreController from "./show_more_controller"
application.register("show-more", ShowMoreController)

import SortablePositionController from "./sortable_position_controller"
application.register("sortable-position", SortablePositionController)

import StarRatingController from "./star_rating_controller"
application.register("star-rating", StarRatingController)

import SubmitGateController from "./submit_gate_controller"
application.register("submit-gate", SubmitGateController)

import SubstitutesController from "./substitutes_controller"
application.register("substitutes", SubstitutesController)

import TextareaAutogrowController from "./textarea_autogrow_controller"
application.register("textarea-autogrow", TextareaAutogrowController)

import ThemeController from "./theme_controller"
application.register("theme", ThemeController)

import UploadDropzoneController from "./upload_dropzone_controller"
application.register("upload-dropzone", UploadDropzoneController)

import UploadFieldController from "./upload_field_controller"
application.register("upload-field", UploadFieldController)

import UploadGateController from "./upload_gate_controller"
application.register("upload-gate", UploadGateController)
